import React, { Component } from 'react'
import BackButton from 'back-button'
import { withStyles } from '@material-ui/core'
import PropTypes from 'prop-types'

const styles = () => ({
    headerBar: {
        // boxShadow: theme.palette.primary.flatBottomShadow,
        width: 'calc(100% - 1px)',
        padding: '0 20px',
        boxSizing: 'border-box',
        zIndex: 1,
        maxHeight: '60px',
        fontSize: '16px',
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0px -1px 2px 0px #D9D8D8 inset',
        background: '#F2F1F1',
        marginLeft: '1px',
        /*
        * Setting height to a value less than min-height
        * will properly center flex items in IE.
        */
        height: '60px',
        minHeight: '60px',
        '&.small-view': {
            background: 'white',
            boxShadow: '0px 0px 0px 0px !important',
            boxSizing: 'none !important',
            marginLeft: 0,
            padding: '22px 20px',
            '&>*:first-child': {
                marginRight: 15
            }
        }

    },
    headerBarChildren: {
        width: '100%',
        flex: '0 1 auto',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center'
    },
    backButton: {
        display: 'flex',
        alignItems: 'center',
        float: 'left'
    },
    customBackButton: {
        alignItems: 'center',
        background: 'none',
        border: 0,
        cursor: 'pointer',
        display: 'flex',
        height: 24,
        justifyContent: 'center',
        padding: 0,
        width: 24
    }
})

class Header extends Component {
    render () {
        const { backButtonIcon, classes, smallView, children, returnFnc } = this.props
        return (

            <div className={`${classes.headerBar} ${smallView ? 'small-view' : ''}`}>
                {smallView
                    ? <div className={classes.backButton}>
                        {backButtonIcon
                            ? <button
                                aria-label='Back'
                                className={classes.customBackButton}
                                onClick={returnFnc}
                                type='button'
                            >
                                {backButtonIcon}
                            </button>
                            : <BackButton onClick={returnFnc}/>
                        }
                    </div>
                    : null}
                <div className={classes.headerBarChildren}>
                    {children}
                </div>
            </div>

        )
    }
}

Header.propTypes = {
    backButtonIcon: PropTypes.node,
    classes: PropTypes.object,
    smallView: PropTypes.bool,
    children: PropTypes.object,
    returnFnc: PropTypes.func
}

export default withStyles(styles)(Header)
